module.exports = __webpack_public_path__ + "assets/img/typeIcon-5-blue.122a7ce0.svg";